import React from 'react'
import Dropzone from 'react-dropzone'

const _ = require('lodash')
const utilities = require('../Utilities')

class Home extends React.Component {

	constructor() {
		super()

		this.state = {
			fileLoaded: false,
		}

		this.onDrop = this.onDrop.bind(this)
	}

	onDrop(file) {

		const reader = new FileReader()
		const blob = _.toPlainObject(file[0])

		reader.onload = (b) => {
			const binary = reader.result
			this.setState({ file: binary })

			const params = {}
			params.method = 'POST'
			params.headers = {
				'x-api-key': 'DYw7efcs7K4WRWnYRjn6E2khkPksFefVav8OyG21'
			}
			params.mode = 'cors'
			params.body = _.trimStart(binary, 'data:image/png;base64, ')
			fetch('https://sjb60cg4lh.execute-api.us-east-1.amazonaws.com/dev/image_box', params)
			.then(res => res.json())
			.then(resJson => console.log(resJson))
			.catch(err => console.log(err))

		}

		reader.onabort = () => console.log('file reading was aborted')
		reader.onerror = () => console.log('file reading has failed')
		reader.readAsDataURL(file[0])

	}


	render() {

		const styles = {
			container: {
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '100%',
				height: '100%',
				backgroundColor: 'lightgrey'
			},
			dropZone: {
				width: '80%',
				height: '80%',
				backgroundColor: 'white',
				borderRadius: 10
			}
		}
		return (
			<div style={styles.container}>
				<Dropzone style={styles.dropZone} onDrop={this.onDrop} />
			</div>
		)
	}
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home.js